// ----------------------------------------------------------------------------
// Cutter
// ----------------------------------------------------------------------------

import vtkMapper from '@kitware/vtk.js/Rendering/Core/Mapper';
import vtkActor from '@kitware/vtk.js/Rendering/Core/Actor';
import vtkCutter from '@kitware/vtk.js/Filters/Core/Cutter';
import vtkPlane from '@kitware/vtk.js/Common/DataModel/Plane';
import vtkProperty from '@kitware/vtk.js/Rendering/Core/Property';
import controlPanel from '../html/controlPanelCutter.html';

const state = {
    originX: -108016,
    originY: 5100343,
    originZ: 55,
    normalX: 1,
    normalY: 0,
    normalZ: 0,
};
let plane;
let cutter;
let renderer;
let renderWindow;;

class vxVtkCutter {
    static init(vtkModel) {
        plane = vtkPlane.newInstance();
        cutter = vtkCutter.newInstance();
        cutter.setCutFunction(plane);
        renderer = vtkModel.renderer;
        renderWindow = vtkModel.renderWindow;

        const cutMapper = vtkMapper.newInstance();
        cutMapper.setInputConnection(cutter.getOutputPort());
        const cutActor = vtkActor.newInstance();
        cutActor.setMapper(cutMapper);
        const cutProperty = cutActor.getProperty();
        cutProperty.setRepresentation(vtkProperty.Representation.WIREFRAME);
        cutProperty.setLighting(false);
        cutProperty.setColor(1, 0, 0);
        renderer.addActor(cutActor);


        // -----------------------------------------------------------
        // UI control handling
        // -----------------------------------------------------------
        const controller = document.createElement('div');
        controller.className = 'controlPanel';
        controller.innerHTML = controlPanel;
        vtkModel.container.parentNode.insertBefore(controller, vtkModel.container);

        // const controller = vtkModel.container.createElement('div');
        // controller.innerHtml=
        // vtkModel.container.appendChild(controlPanel);

        //renderWindow.addController(controlPanel);
        ['originX', 'originY', 'originZ', 'normalX', 'normalY', 'normalZ'].forEach(
            (propertyName) => {
                const elem = document.querySelector(`.${propertyName}`);
                elem.addEventListener('input', (e) => {
                    const value = Number(e.target.value);
                    state[propertyName] = value;
                    vxVtkCutter.updatePlaneFunction();
                    return false;
                });
            }
        );

    }

    static updatePlaneFunction = () => {
        plane.setOrigin(state.originX, state.originY, state.originZ);
        plane.setNormal(state.normalX, state.normalY, state.normalZ);
        renderWindow.render();
    };

    static setSource(source) {
        cutter.setInputConnection(source.getOutputPort());
    }
}

export default vxVtkCutter;